import React, { useEffect, useState } from 'react';
import { Spin, Alert } from 'antd';
import { useGlobalContext } from '../../store/GlobalContext';
import Cookies from 'js-cookie';
import axios from 'axios';
import DOMPurify from 'dompurify';

const TreeRenderer: React.FC = () => {
  const { selectedEstate, auth } = useGlobalContext();
  
  const { user } = auth;
  const userId = user ? user.uid : '';
  const estateId = selectedEstate ? selectedEstate.uuid : '';


  const [htmlContent, setHtmlContent] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {

    if (!estateId || !userId) {
      setError('Estate ID or User ID is missing.');
      setLoading(false);
      return;
    }

    // Fetch HTML content from the API
    const fetchHtmlContent = async () => {
      try {
        const token = Cookies.get('accessToken') || Cookies.get('token'); // Adjust based on your token storage
        if (!token) {
          setError('Unauthorized. Please log in.');
          setLoading(false);
          return;
        }

        const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:4000/api';

        const response = await fetch(`${REACT_APP_API_BASE_URL}/relationships/${estateId}/${userId}/tree`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'text/html', // Ensure correct content type
          },
        });

        if (!response.ok) {
          const errorMessage = `Error fetching content: ${response.statusText}`;
          throw new Error(errorMessage);
        }

        const html = await response.text();

        console.log(html,"html");

        // const sanitizedHtml = DOMPurify.sanitize(html);
        setHtmlContent(html);
      } catch (err: any) {
        console.error(err);
        if (axios.isAxiosError(err)) {
          setError(err.response?.data?.message || 'Failed to fetch family tree.');
        } else {
          setError(err.message || 'Failed to fetch family tree.');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchHtmlContent();
  }, [estateId, userId]);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '2rem' }}>
        <Spin tip="Loading tree..." />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: '24px', background: '#fff' }}>
        <Alert message="Error" description={error} type="error" showIcon />
      </div>
    );
  }

  return (
    <>
    {
      htmlContent && (
      <iframe
          srcDoc={htmlContent || ''}
          style={{
            width: '100%',
            height: '800px',
            border: 'none',
            padding: '24px',
            background: '#fff'
          }}
        />
    )
    }
    </>

    
  );
};

export default TreeRenderer;
